import React from 'react';
import { Chip } from '@mui/material';
import { ROLE_LABELS, ROLE_COLORS } from '../constants/roles';

// Single shared role badge — every screen that shows a user's role (the
// Users table, ConversationViewer, the Email Invites list, etc.) renders it
// through this component so a role reads as the same color everywhere.
//
// MUI's Chip `color` prop is a closed enum (default/primary/secondary/error/
// info/success/warning) that can't express ROLE_COLORS' teal, so this skips
// the `color` prop entirely and styles from the hex map via `sx` instead —
// that's the one system all four roles share. See ROLE_COLORS in
// constants/roles.js for the per-role hex values and their contrast numbers.
export default function RoleChip({ role, size = 'small', sx }) {
  const label = ROLE_LABELS[role] || role || 'Unknown';
  const color = ROLE_COLORS[role] || '#616161';
  return (
    <Chip
      label={label}
      size={size}
      variant="outlined"
      sx={{
        color,
        borderColor: color,
        fontWeight: 600,
        // Deliberately no tinted fill: a tinted background measurably drops
        // the text/border contrast (SCHOOL_ADMIN's blue falls under 4.5:1
        // AA against even an 8%-alpha tint of itself), and this chip has to
        // stay legible on whatever background it's dropped onto (white
        // cards, table rows, dialog panels) — plain white/transparent is
        // the only bg every consumer is guaranteed to share.
        backgroundColor: 'transparent',
        ...sx,
      }}
    />
  );
}
